export { default } from "./StudentAssignmentInformation";
